<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Revenue Trekking Office Wise Report</h3>
        <div class="text-xs-right">
          <export-summary-report-button model="trekking-office-wise" :export-date="range" :export-office="office"
                                        v-if="$oauth.checkIfHasPermission(['export trekking-revenue-office-wise-summary-report'])"/>
          <refresh-button :click-function="updateByTrekkingAgency"></refresh-button>
        </div>
      </v-flex>
      <v-flex xs12>

        <v-card>
          <v-layout class="py-1 mx-2" row wrap>
            <v-flex xs6 class="d-flex align-center">
              <custom-date-range-picker @change="updateByTrekkingAgency"
                                        v-model="range"/>
            </v-flex>
            <v-flex xs6>
              <v-autocomplete
                  :items="offices"
                  chips
                  clearable
                  deletable-chips
                  flat
                  hide-details
                  item-text="name"
                  item-value="id"
                  label="Filter By Office"
                  multiple
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="office"
                  @change="updateByTrekkingAgency"
              ></v-autocomplete>
            </v-flex>

          </v-layout>

          <v-divider/>
          <v-card-text class="pa-0">
            <v-simple-table
                class="elevation-0 pb-6"
                v-if="$oauth.checkIfHasPermission(['read trekking-revenue-office-wise-summary-report'])"
            >
              <thead>
              <!--              <v-progress-linear-->
              <!--                  :active="progressLinearLoading"-->
              <!--                  :indeterminate="progressLinearLoading"-->
              <!--                  absolute-->
              <!--                  bottom-->
              <!--                  color="primary"-->
              <!--              ></v-progress-linear>-->
              <v-overlay :value="progressLinearLoading">
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>
              </v-overlay>
              <tr>
                <th class="text-center">S.N</th>
                <th class="text-left">Agency Name</th>
                <th class="text-left">No. of permit issued</th>
                <th class="text-center">Revenue amount(USD)</th>
                <th class="text-center">Revenue amount(NPR)</th>
              </tr>
              </thead>
              <tbody v-if="trekking_route_wise_data !== []">
              <tr v-for="(item,i) in trekking_route_wise_data">
                <td class="text-center">{{ i + 1 }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.no_of_trekking_permit }}</td>
                <td class="font-weight-bold text-center">{{ item.total_cost }}</td>
                <td class="font-weight-bold text-center">{{ item.total_cost_npr }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td class="text-center" colspan="2">Total</td>
                <td class="text-center">{{ total_trekking_permit }}</td>
                <td class="text-center">{{ total_total_amount }}</td>
                <td class="text-center">{{ total_total_amount_npr }}</td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr>
                <td><h3 class="text-center">No record found</h3></td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import CustomDateRangePicker from "../../components/CustomDateRangePicker";
import {commonStoreMixin} from "../../mixins/commonStoreMixin";
import IssuedVisaFooter from "../../components/footer/IssuedVisaFooter";
import ExportSummaryReportButton from "../../components/ExportSummaryReportButton";
import ExportButton from "../../components/ExportButton";
import Http from "axios";
import {VERSIONED_API_URL} from "../../config/config";
import RefreshButton from "@/components/RefreshButton";

const REVENUE_SUMMARY_REPORT_URL = `${VERSIONED_API_URL}/summary-report/trekking-office-wise`;

export default {
  name: "TrekkingAgencyWise",
  data() {
    return {
      trekking_route_wise_data: [],
      range: {},
      office: [],
      total_total_amount: 0,
      total_total_amount_npr: 0,
      total_trekking_permit: 0
    };
  },
  components: {RefreshButton, CustomDateRangePicker, IssuedVisaFooter, ExportSummaryReportButton},
  mixins: [commonStoreMixin],
  computed: {
    ...mapGetters({
      loading: "ArrivalDepartureReport/reportLoading",
    }),
    offices() {
      return this.$store.state.OfficeList.offices;
    },
  },
  methods: {
    ...mapActions({fetchOffices:'OfficeList/fetchAll'}),
    arrivedReport(item) {
      let params = {fromAD: true, type: 'Arrival', country: item.country};
      this.$router.push({
        name: 'ArrivalDepartureReport',
        params: params
      });

    },
    departedReport(item) {
    },
    updateByTrekkingAgency() {
      let params = {};
      this.progressLinearLoading = true;
      if (Object.keys(this.range).length > 0)
        params.date_range = this.range;
      if (this.office)
        params.office = this.office;

      Http.get(REVENUE_SUMMARY_REPORT_URL, {
        params: params
      })
          .then((res) => {
            this.total_total_amount = 0;
            this.total_total_amount_npr = 0;
            this.total_trekking_permit = 0;
            this.trekking_route_wise_data = res.data.data;
            if (this.trekking_route_wise_data.length) {
              this.trekking_route_wise_data.forEach(item => {
                this.total_total_amount += item.total_cost;
                this.total_trekking_permit += item.no_of_trekking_permit;
                this.total_total_amount_npr += parseFloat(item.total_cost_npr);
              })
            } else {
              this.total_total_amount = 0;
              this.total_trekking_permit = 0;
              this.total_total_amount_npr = 0;
            }
            this.progressLinearLoading = false;
            // this.getData();
          })
          .catch(() => {
            this.$store.commit('Notification/showError', 'Something went wrong');
            this.progressLinearLoading = false;
          });
    }


  },
  mounted() {
    this.progressLinearLoading = true;
    this.fetchOffices();
    Http.get(REVENUE_SUMMARY_REPORT_URL)
        .then((res) => {
          this.trekking_route_wise_data = res.data.data;
          this.trekking_route_wise_data.forEach(item => {
            this.total_trekking_permit += item.no_of_trekking_permit;
            this.total_total_amount += parseFloat(item.total_cost);
            this.total_total_amount_npr += parseFloat(item.total_cost_npr);
          })
          this.progressLinearLoading = false;
          // this.getData();
        })
        .catch(() => {
          this.progressLinearLoading = false;
        });

    this.range = {
      start: new Date().toISOString().substr(0, 10),
      end: new Date().toISOString().substr(0, 10)
    }
  }
}
</script>
